// extracted by mini-css-extract-plugin
module.exports = {"closeBtnReact":"closeBtn-module_closeBtnReact_jEzaf","closeBtnReact__icon":"closeBtn-module_closeBtnReact__icon_1eWGN"};